"use client";

import { useSectionNavTheme } from "@/app/hooks/useSectionNavTheme";
import { Heading2 } from "../typography";
import { useRef } from "react";
import { PinnedScrollSection } from "../shared";

export const TheResults = () => {
  const sectionRef = useRef<HTMLDivElement | null>(null);

  const achievements = [
    {
      title: "20-year trend analysis",
      description:
        "revealing patterns invisible to traditional monitoring approaches, providing objective measurements to replace subjective assessments with verifiable data.",
    },
    {
      title: "Quantified development impacts",
      description:
        "providing objective evidence for policy decisions with unprecedented spatial and temporal detail, enabling predictive capabilities for proactive environmental management.",
    },
    {
      title: "Habitat condition mapping",
      description:
        "with comprehensive environmental intelligence delivering actionable insights that support defensible policy positions backed by rigorous scientific analysis.",
    },
    {
      title: "15 legislative recommendations",
      description:
        "for environmental protection and urban planning reform, directly informing a comprehensive government report tabled in the ACT Legislative Assembly.",
    },
  ];

  useSectionNavTheme({
    trigger: "#act-results",
    isDark: true,
    start: "center center",
    end: () => `+=${achievements.length * 500 + window.innerHeight}`,
  });

  return (
    <div
      ref={sectionRef}
      id="act-results"
      className="pt-20 pb-64 lg:pt-44 relative overflow-hidden"
    >
      {/* Background Blobs */}
      <div className="absolute inset-0 opacity-10 pointer-events-none">
        <div className="absolute top-20 right-10 w-96 h-96 bg-haizea-orange/30 rounded-full blur-3xl" />
        <div className="absolute bottom-20 left-10 w-[500px] h-[500px] bg-haizea-blue/20 rounded-full blur-3xl" />
        <div className="absolute top-1/2 right-1/4 w-64 h-64 bg-haizea-green/25 rounded-full blur-2xl" />
      </div>

      <div className="results-content">
        <div className="max-w-[710px] mx-auto">
          <PinnedScrollSection
            title={
              <Heading2 className="text-slate-600 dark:text-slate-100 leading-tight">
                <span className="text-haizea-green">Insights That Can </span>
                Change Policy
              </Heading2>
            }
            items={achievements}
            contentClassName="lg:h-[40vh]"
            yOffset={110}
            rangeBackground="linear-gradient(90deg, var(--color-haizea-orange) 0%, var(--color-haizea-green) 50%, var(--color-haizea-blue) 100%)"
            titleClassName="font-medium"
            descriptionClassName="text-slate-600 dark:text-slate-300"
            itemClassName="text-slate-700 dark:text-slate-200 my-4"
          />
        </div>
      </div>
    </div>
  );
};
